import React from 'react';
import styled from 'styled-components';
import { boxShadow } from 'Utils/utilsStyle';
import SkeletonCustom from './SkeletonCustom';

const Wrapper = styled.div`
display: flex;
align-items: center;
justify-content: space-between;
box-shadow: ${boxShadow};
margin-bottom: 10px;
padding: 16px 32px;
border-radius: 13px;
.name-div {
  display: flex;
  align-items: center;
}
`;

const DocumentDetailSkeleton = function DocumentDetailSkeleton() {
  return (
    <Wrapper className="document-detail-skeleton-wrapper">
      <div className="name-div">
        <SkeletonCustom
          height="45px"
          width="45px"
          margin="0px 10px 0px 0px"
          marginSm="0px 10px 0px 0px"
        />
        <SkeletonCustom
          height="30px"
          width="190px"
          margin="0px 0px 0px 0px"
          marginSm="0px 0px 0px 0px"
        />
      </div>
      {[1, 2, 3].map(() => (
        <SkeletonCustom
          height="30px"
          width="190px"
          margin="0px 0px 0px 0px"
          marginSm="0px 0px 0px 0px"
        />
      ))}
    </Wrapper>
  );
};
export default DocumentDetailSkeleton;
